<script>
  import { registrationSection } from '../sections/registration.js';
  import {
    smsCode,
    smsError,
    isSubmitting,
    isResending,
    step,
    verifyCode,
    resendCode,
    resetForm
  } from '../stores/registration.js';

  export let productId;
  export let onSuccess = undefined;
  export let onAfterPayment = undefined;

  function onInput(event) {
    smsCode.set(event.currentTarget.value.replace(/\D/g, ''));
  }

  function submit() {
    verifyCode(productId, onSuccess, onAfterPayment);
  }

  function onKeydown(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      submit();
    }
  }

  function backToForm() {
    resetForm();
  }
</script>

{#if $step === 'verify'}
  <div class="overlay" role="dialog" aria-modal="true" aria-labelledby="verify-title">
    <div class="overlay-card">
      <h2 id="verify-title">{registrationSection.verify.title}</h2>
      <p class="description">{registrationSection.verify.description}</p>

      <input
        class="input"
        type="text"
        inputmode="numeric"
        maxlength="6"
        placeholder={registrationSection.verify.placeholder}
        value={$smsCode}
        on:input={onInput}
        on:keydown={onKeydown}
      />

      {#if $smsError}
        <p class="message">{$smsError}</p>
      {/if}

      <button class="primary" type="button" on:click={submit} disabled={$isSubmitting || $isResending}>
        {$isSubmitting ? 'Загрузка...' : registrationSection.verify.submit}
      </button>

      <button class="link" type="button" on:click={resendCode} disabled={$isSubmitting || $isResending}>
        {$isResending ? 'Отправка...' : registrationSection.verify.resend}
      </button>

      <button class="link muted" type="button" on:click={backToForm} disabled={$isSubmitting || $isResending}>
        {registrationSection.verify.back}
      </button>

      <p class="help-fallback">
        Не приходит код или ошибка оплаты?
        <a href="https://max.ru/u/f9LHodD0cOJ1otgVx9KGa4maaCIVqQH5TX7X3JwN8a8incQQs69OylZpCCU" target="_blank" rel="noreferrer">
          Написать организатору
        </a>
      </p>
    </div>
  </div>
{/if}

<style>
  .overlay {
    position: fixed;
    inset: 0;
    z-index: 1100;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.9);
    backdrop-filter: blur(6px);
    padding: 16px;
  }

  .overlay-card {
    width: 100%;
    max-width: 480px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 24px;
    padding: 48px;
    border-radius: 24px;
    background: #1a1c1d;
    color: #ffffff;
    box-sizing: border-box;
  }

  h2 {
    margin: 0;
    color: #ffffff;
    font-size: 32px;
    font-weight: 800;
    line-height: 1.15;
    text-align: center;
  }

  .description {
    margin: 0;
    color: rgba(255, 255, 255, 0.7);
    font-size: 16px;
    line-height: normal;
    text-align: center;
  }

  .input {
    width: 100%;
    height: 51px;
    padding: 14px 16px;
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 16px;
    background: transparent;
    color: #ffffff;
    font-size: 20px;
    font-weight: 400;
    text-align: center;
    outline: none;
    box-sizing: border-box;
    transition: border-color 160ms ease;
  }

  .input:focus {
    border-color: #e7b962;
  }

  .message {
    margin: 0;
    color: #ff6b6b;
    font-size: 14px;
    text-align: center;
  }

  .primary {
    width: 100%;
    padding: 13px;
    border: 0;
    border-radius: 5px;
    background: #e7b962;
    color: #000000;
    font-family: Roboto, Arial, sans-serif;
    font-size: 18px;
    font-weight: 500;
    text-transform: uppercase;
    cursor: pointer;
    transition: background-color 160ms ease;
  }

  .primary:hover:not([disabled]),
  .primary:focus-visible:not([disabled]) {
    background: #ffa800;
  }

  .primary[disabled] {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .link {
    background: none;
    border: 0;
    padding: 0;
    color: rgba(231, 185, 98, 0.7);
    font-family: Manrope, Roboto, Arial, sans-serif;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: color 160ms ease;
  }

  .link:hover:not([disabled]),
  .link:focus-visible:not([disabled]) {
    color: #e7b962;
  }

  .link.muted {
    color: rgba(255, 255, 255, 0.6);
    font-size: 16px;
  }

  .link.muted:hover:not([disabled]),
  .link.muted:focus-visible:not([disabled]) {
    color: #ffffff;
  }

  .link[disabled] {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .help-fallback {
    margin: 8px 0 0;
    color: rgba(255, 255, 255, 0.7);
    font-size: 14px;
    line-height: 20px;
    text-align: center;
  }

  .help-fallback a {
    color: #ffa800;
    text-decoration: underline;
    text-underline-offset: 2px;
  }

  .help-fallback a:hover,
  .help-fallback a:focus-visible {
    color: #e7b962;
  }
</style>
